const hasLinksInBlock = (block, contentState) => {
  return getLinkRangesInBlock(block, contentState).length > 0;
};
const getLinkRangesInBlock = (block, contentState) => {
  const ranges = [];
  block.entityRanges.forEach((entityRange) => {
    var _a;
    const entityType = (_a = contentState.entityMap[entityRange.key]) == null ? void 0 : _a.type;
    if (entityType === "LINK" || entityType === "wix-draft-plugin-external-link") {
      const start = entityRange.offset;
      const end = start + entityRange.length;
      ranges.push([start, end]);
    }
  });
  return ranges;
};

export { getLinkRangesInBlock, hasLinksInBlock };
//# sourceMappingURL=draftUtils.js.map
